/* eslint-disable no-restricted-globals */
import React, { Component, createRef } from "react";
import { Button, Col, message, Modal, Row, Segmented, Typography } from "antd";
import { ReadOutlined } from "@ant-design/icons";
import CountdownTimer from "@/components/Train/countdown";
import Question from "../components/question.jsx";
import "./examTask.less";
import submitImg from "@/assets/submit.png";
import introImg from "@/assets/intro.png";
import hourglassImg from "@/assets/hourglass.png";
import trainImg from "@/assets/train.png";
import reExamImg from "@/assets/reExam.png";
import successImg from "@/assets/success.png";
import errorImg from "@/assets/error.png";
//语言切换
import intl from "react-intl-universal";
import en_US from "@/locales/en_US/index.json";
import zh_CN from "@/locales/zh_CN/index.json";
// import { withRouter } from 'react-router-dom';
import Watermark from "../components/WaterMark/waterMark.jsx";
import { getUserInfoToLocal } from "../../../../utils/auth.js";
import Document from "../components/document";
import {
  checkExamTask,
  getExamTaskStatus,
  getExamTrainList,
  redoTrainTaskQuestion,
  submitExam,
  toExam,
  toExamQuestion,
} from "../../../../services/exam.js";
import { limitTrainTask } from "../../../../services/train.js";
import {
  clearUserExamInfo,
  getUserExamInfo,
  guid,
  saveUserExamInfo,
} from "../../../../utils/utils.js";

//qiankun
import microApp from "../../../../utils/qiankun.js";

const locales = {
  en_US,
  zh_CN,
};

const { Text } = Typography;

//考试任务
class Task extends Component {
  state = {
    dataInfo: undefined,
    examQuestionInfo: undefined, //考试题目信息
    examTrainList: undefined, //考试关联的培训任务
    pageStatus: "", //当前考试界面状态类型：exam：考试，examResult：考试答案，passResult：考试通过结果
    tabValue: 1, //当前tab选项
    trainListModal: false, //关联培训内容弹窗
    tipsModal: false, //超时，切屏等弹窗
    tipsType: "", //超时，切屏等弹窗内容
    workTypeId: "", //GAI使用，节点类型
    practiceId: "",
    docVisible: false,
    previewFileList: [],
  };

  useTime = 0;
  idleTimeoutListener = undefined; //无操作监听事件
  timeoutListener = undefined; //作答超时监听事件
  changeTabCount = 0;
  params = this.props.match.params;
  containerRef = createRef();

  async initData() {
    if (this.params.status === "previewOtherExam") {
      const queryString = window.location.search;
      const searchParams = new URLSearchParams(queryString);
      const practiceId = searchParams.get("practiceId") || "";
      this.setState({
        practiceId: practiceId,
        workTypeId: searchParams.get("type") || "",
      });
      this.handleShowExamResult(this.params.id, "", practiceId);
    } else {
      //获取考试任务数据：若未提交考试则展示考试题目
      //timeoutTime 未操作超时，switchingTimes切屏
      let practiceId = "";
      let dataInfo;
      await toExam(this.params.id).then((res) => {
        if (res && res.code === 0 && res.data) {
          this.setState({
            dataInfo: { ...res.data, ...res.data.extend },
            practiceId: res.data.practices[0].id,
          });
          dataInfo = { ...res.data, ...res.data.extend };
          practiceId = res.data.practices[0].id;
        }
      });
      toExamQuestion({ practiceId: practiceId }).then((res) => {
        if (res && res.code === 0) {
          this.setState({
            workTypeId: res.data.workTypeId,
          });
          const questionList = res.data;
          const keyObj = {
            0: "",
            1: intl.get("sentenceAccuracy"),
            2: intl.get("accurateWord"),
            3: intl.get("phoneticAccuracy"),
            4: intl.get("correctRhythm"),
          };
          if (res.data.scoreType) {
            let passingScore = [];
            Object.keys(res.data.scoreType).forEach((key) => {
              passingScore.push(
                keyObj[key] +
                  (res.data.totalScore ? "分:" : ":") +
                  (res.data.totalScore
                    ? Math.round(
                        (res.data.scoreType[key] * res.data.totalScore) / 100
                      )
                    : res.data.scoreType[key] + "%")
              );
            });
            res.data.passingScore = passingScore;
          }
          if (res.data.accuracy) {
            let accuracyScore = [];
            Object.keys(res.data.accuracy).forEach((key) => {
              accuracyScore.push(
                keyObj[key] +
                  (key === "0" ? "" : res.data.totalScore ? "分:" : ":") +
                  (res.data.totalScore
                    ? Math.round(
                        (res.data.accuracy[key] * res.data.totalScore) / 100
                      )
                    : res.data.accuracy[key] + "%")
              );
            });
            res.data.accuracyScore = accuracyScore;
          }
          if (questionList) {
            this.setState({
              examQuestionInfo: questionList,
            });
            if (questionList.isSubmit === 1) {
              clearUserExamInfo(questionList.id);
              //考官查看展示答案分析页，考生查看展示考试通过结果
              if (this.params.status === "exam") {
                getExamTrainList(practiceId).then((res) => {
                  if (res && res.code === 0) {
                    this.setState({
                      examTrainList: res.data,
                    });
                  }
                });
                this.setState({
                  pageStatus: "passResult",
                });
              } else {
                this.setState({
                  pageStatus: "examResult",
                });
                this.handleShowExamResult(questionList.id);
              }
            } else {
              this.setState({
                pageStatus: "exam",
              });
              if (res.data.files && res.data.files.length > 0) {
                //查看培训文档
                this.setState({
                  previewFileList: res.data.files.sort(
                    (a, b) => a.sort - b.sort
                  ),
                });
              } else {
                this.setState({
                  previewFileList: [],
                });
              }
              if (this.params.status === "exam") {
                this.initListener(res.data, dataInfo);
                window.addEventListener("beforeunload", (e) =>
                  this.beforeUnload(e)
                );
              } else {
                if (!this.state.tipsModal) {
                  this.setState({
                    tipsType: "introduce",
                    tipsModal: true,
                  });
                }
              }
              //定位到未做的第一道题目
              const undoQuestionList = questionList.questions.filter(
                (item) => item.status === 0
              );
              if (undoQuestionList.length > 0) {
                const questionDom = document.getElementById(
                  `question-${undoQuestionList[0].id}`
                );
                if (questionDom)
                  questionDom.scrollIntoView({
                    behavior: "smooth", // 平滑滚动
                  });
              }
            }
          }
        }
      });
    }
  }

  componentDidMount() {
    intl
      .init({
        currentLocale: localStorage.getItem("language_type") || "zh_CN",
        locales,
      })
      .then(() => {});
    this.initData();
  }

  componentDidUpdate(prevProps, prevState) {
    const keys = ["pageStatus", "workTypeId", "examQuestionInfo"];
    if (keys.filter((key) => prevState[key] !== this.state[key]).length > 0) {
      if (
        ["examResult", "exam"].includes(this.state.pageStatus) &&
        this.state.workTypeId &&
        this.state.examQuestionInfo &&
        this.state.examQuestionInfo.taskPacketId
      ) {
        setTimeout(() => {
          if (microApp.isMounted) {
            const event = new CustomEvent("microChange", {
              detail: {
                workUnitId: this.state.examQuestionInfo.taskPacketId,
                pageStatus: this.state.pageStatus,
                practiceId: this.state.practiceId,
                accuracy: this.state.examQuestionInfo.accuracy,
              },
            });
            window.dispatchEvent(event);
          } else {
            microApp.load(this.containerRef.current, {
              workUnitId: this.state.examQuestionInfo.taskPacketId,
              pageStatus: this.state.pageStatus,
              preCheck: this.isLarge,
              practiceId: this.state.practiceId,
              accuracy: this.state.examQuestionInfo.accuracy,
            });
          }
        });
      } else {
        microApp.unload();
      }
    }
  }

  componentWillUnmount() {
    microApp.unload();
    window.removeEventListener("beforeunload", this.beforeUnload);
  }

  initListener = (data, dataInfo) => {
    let info = dataInfo || this.state.dataInfo;
    if (!this.state.tipsModal) {
      this.setState({
        tipsType: "introduce",
        tipsModal: true,
      });
    }
    setTimeout(() => {
      this.isLarge();
    }, 0);
    this.switchListener(data, info);
    this.setupIdleDetection(data, info);

    document.oncontextmenu = new Function("event.returnValue=false"); // 禁用鼠标右键
    document.onselectstart = new Function("event.returnValue=false"); // 禁用鼠标选中
  };

  setupIdleDetection(data, info) {
    if (info && info.timeoutTime && data) {
      if (getUserExamInfo("timeout", data.historyId)) {
        this.userIsIdle(data);
      }
      // 监听鼠标移动事件
      document.addEventListener("mousemove", () =>
        this.resetIdleTimeout(data, info)
      );
      // 监听键盘按键按下事件
      document.addEventListener("keydown", () =>
        this.resetIdleTimeout(data, info)
      );
      if (!this.idleTimeoutListener) {
        // 初始化闲置超时
        this.idleTimeoutListener = setTimeout(
          () => this.userIsIdle(data),
          info.timeoutTime * 1000
        );
      }
    }
  }

  resetIdleTimeout(data, info) {
    if (data && info.timeoutTime && this.idleTimeoutListener) {
      clearTimeout(this.idleTimeoutListener);
      this.idleTimeoutListener = undefined;
      this.idleTimeoutListener = setTimeout(
        () => this.userIsIdle(data),
        info.timeoutTime * 1000
      );
    }
  }

  // 闲置检测
  userIsIdle(data) {
    saveUserExamInfo("timeout", true, data.historyId);
    if (!this.state.tipsModal) {
      this.setState({
        tipsType: "noOperate",
        tipsModal: true,
      });
    } else if (this.state.tipsType !== "noOperate") {
      this.setState({
        tipsType: "noOperate",
      });
    }
  }

  // 监听窗口是否最大化
  isLarge = () => {
    const isWidthMatch =
      Math.abs(window.outerWidth - screen.availWidth) <= 20;
    const isHeightMatch =
      Math.abs(window.outerHeight - screen.availHeight) <= 150;
    if (!isWidthMatch || !isHeightMatch) {
      this.largeJudge();
      return false;
    }
    return true;
  };

  switchListener = (data, info) => {
    // 监听切换
    if (info && info.switchingTimes && data) {
      const switchTimes = getUserExamInfo("swicthTimes", data.historyId) ?? 0;
      if (info.switchingTimes > 0 && switchTimes < info.switchingTimes) {
        document.addEventListener("visibilitychange", (e) => {
          if (
            (this.changeTabCount + 1) / 2 >
            info.switchingTimes - switchTimes
          ) {
            if (!this.state.tipsModal) {
              this.setState({
                tipsType: "switch",
                tipsModal: true,
              });
            } else if (this.state.tipsType !== "switch") {
              this.setState({
                tipsType: "switch",
              });
            }
          } else {
            saveUserExamInfo(
              "swicthTimes",
              switchTimes + (this.changeTabCount + 1) / 2,
              data.historyId
            );
          }
          this.changeTabCount++;
        });
      } else {
        if (!this.state.tipsModal) {
          this.setState({
            tipsType: "switch",
            tipsModal: true,
          });
        } else if (this.state.tipsType !== "switch") {
          this.setState({
            tipsType: "switch",
          });
        }
      }
    }
  };

  beforeUnload = (e) => {
    if (
      this.params.status === "exam" &&
      this.state.pageStatus === "exam" &&
      this.state.examQuestionInfo &&
      this.state.examQuestionInfo.isSubmit !== 1
    ) {
      if (this.state.dataInfo && this.state.dataInfo.switchingTimes) {
        const switchTimes =
          getUserExamInfo("swicthTimes", this.state.examQuestionInfo.id) ?? 0;
        saveUserExamInfo(
          "swicthTimes",
          switchTimes + 1,
          this.state.examQuestionInfo.id
        );
      }
      const data = this.state.examQuestionInfo;
      data.useTime = this.useTime;
      this.setState(
        {
          examQuestionInfo: data,
        },
        () => {
          this.savePracticeQueation();
        }
      );
    }
    // e.preventDefault();
  };

  showExamTips = () => {
    Modal.confirm({
      title: intl.get("Tips_f41babef-2238-24b3-8e39-bdb7bcb07d16"),
      content: (
        <div className="mT20">
          <div>
            {intl.get("eaf218b7-0481-2ac2-ad8f-73c784eb4dfd", {
              hour: this.state.dataInfo?.examTimeH,
              minute: this.state.dataInfo?.examTimeM,
            })}
          </div>
          {/*没有设置时间和次数时不展示警告提示 */}
          {(this.state.dataInfo?.switchingTimes ||
            this.state.dataInfo?.timeoutTime) && (
            <div className="warnTips">
              {intl.get("8d8ccb8c-f131-215b-8054-084fb74e4a1a")}
              {this.state.dataInfo?.switchingTimes &&
                intl.get("eb55eff7-baba-22e5-87b8-6b4f437fa33c", {
                  count: this.state.dataInfo?.switchingTimes,
                })}
              {this.state.dataInfo?.timeoutTime &&
                intl.get("5a1415e7-9207-27f7-a621-65113cacce28", {
                  second: this.state.dataInfo?.timeoutTime,
                })}
              {intl.get("5efb4498-bad0-28d1-ae9b-aab59ae5c35a")}
            </div>
          )}
        </div>
      ),
      centered: true,
      okText: intl.get("ffab6c18-d433-2358-9e00-55e04781c4c6"),
      cancelText: intl.get("Cancel_51f2be22-0a99-2045-95f1-81feae4ea69d"),
      onOk: this.handleReExam,
    });
  };

  //重考确认弹窗
  showReExamConfirm = () => {
    Modal.confirm({
      title: intl.get("Tips_f41babef-2238-24b3-8e39-bdb7bcb07d16"),
      content: (
        <p className="mT20">
          {intl.get("855b4f2b-579e-2a59-a4ac-d6673b1afdcb")}
        </p>
      ),
      centered: true,
      okText: intl.get("ffab6c18-d433-2358-9e00-55e04781c4c6"),
      cancelText: intl.get("Cancel_51f2be22-0a99-2045-95f1-81feae4ea69d"),
      onOk: this.showExamTips,
    });
  };

  showTimeoutConfirm = () => {
    if (!this.state.tipsModal) {
      this.setState({
        tipsType: "timeout",
        tipsModal: true,
      });
    } else if (this.state.tipsType !== "timeout") {
      this.setState({
        tipsType: "timeout",
      });
    }
  };

  countdownSecond = (settingTime, currentSecond) => {
    this.useTime = settingTime - currentSecond + 1;
  };

  getTime = () => {
    const settingTime =
      Number(this.state.dataInfo?.examTimeH) * 60 * 60 +
      Number(this.state.dataInfo?.examTimeM) * 60;
    const remainTime = Number(this.state.examQuestionInfo?.examRestTime);
    if (remainTime > 0) {
      clearTimeout(this.timeoutListener);
      this.timeoutListener = setTimeout(
        this.showTimeoutConfirm,
        remainTime * 1000
      );
      return (
        <CountdownTimer
          targetSeconds={remainTime}
          onTimeLeftChange={(second) =>
            this.countdownSecond(settingTime, second)
          }
          key={remainTime}
        />
      );
    } else {
      this.showTimeoutConfirm();
      return "00:00:00";
    }
  };

  formatSaveQuestionAnswer = () => {
    const data = this.state.examQuestionInfo;
    data.questions.map((item) => {
      const selectAnswerList = [];
      item.options.filter((o) => {
        if (o.answer) {
          selectAnswerList.push(o.id);
        }
      });
      //本选项是正确答案，并且选中该选项
      item.selectQuestionOptionId = selectAnswerList.join(",");
    });
    return data;
  };

  //保存
  savePracticeQueation = () => {
    if (
      this.state.pageStatus !== "exam" ||
      this.state.examQuestionInfo.isSubmit === 1 ||
      this.params.status !== "exam"
    ) {
      return;
    }
    const data = this.formatSaveQuestionAnswer();
    this.setState(
      {
        examQuestionInfo: data,
      },
      () => {
        submitExam({
          id: data.historyId,
          isSubmit: 0,
          useTime: data.useTime,
          practicePaperList: data.questions,
        }).then((res) => {
          if (res && res.code === 0) {
            message.info(intl.get("7556b924-722b-2327-b5f8-41e6c8ce7f0a"));
          }
        });
      }
    );
  };

  //展示最大化提示弹窗
  largeJudge = () => {
    if (!this.state.tipsModal) {
      this.setState({
        tipsType: "fullscreen",
        tipsModal: true,
      });
    }
  };

  //题目数据发生变化 实时保存
  changeQuestion = (index, operateType, key, value) => {
    if (operateType === "change") {
      this.state.examQuestionInfo.questions[index][key] = value;
    }
    this.savePracticeQueation();
  };

  //重新考试
  handleReExam = () => {
    redoTrainTaskQuestion({ practiceId: this.state.practiceId }).then((res) => {
      if (res && res.code === 0) {
        this.setState(
          {
            pageStatus: "exam",
            tabValue: 1,
            tipsModal: false,
            examQuestionInfo: res.data,
          },
          () => {
            this.initListener(res.data);
            window.addEventListener("beforeunload", (e) =>
              this.beforeUnload(e)
            );
          }
        );
      }
    });
  };

  showSubmitModal = () => {
    const data = this.formatSaveQuestionAnswer();
    this.setState({
      examQuestionInfo: data,
    });
    const undoQuestionList = [];
    data.questions.map((item, index) => {
      if (!item.selectQuestionOptionId) {
        undoQuestionList.push(index + 1);
      }
    });
    if (undoQuestionList.length > 0) {
      if (!this.state.tipsModal) {
        this.setState({
          tipsType: `submitNoDone-${undoQuestionList.join(",")}`,
          tipsModal: true,
        });
      } else {
        this.setState({
          tipsType: `submitNoDone-${undoQuestionList.join(",")}`,
        });
      }
    } else {
      if (!this.state.tipsModal) {
        this.setState({
          tipsType: "submitDone",
          tipsModal: true,
        });
      } else {
        this.setState({
          tipsType: "submitDone",
        });
      }
    }
  };

  // 提交练习
  handleSubmitClick = async (notCheck = false) => {
    //如果是嵌套的其他微服务，可能需要保存一下数据，比如TTS的当前数据
    if (
      window.__MICRO_PRE_SUNMIT__ &&
      typeof window.__MICRO_PRE_SUNMIT__ === "function"
    ) {
      const res = await window.__MICRO_PRE_SUNMIT__(notCheck);
      if (!res) {
        this.setState({
          tipsModal: false,
        });
        return;
      }
    }
    const data = this.formatSaveQuestionAnswer();
    data.useTime = this.useTime;
    data.isSubmit = 1;
    submitExam({
      id: data.historyId,
      isSubmit: 1,
      useTime: data.useTime,
      practicePaperList: data.questions,
    }).then((res) => {
      if (res && res.code === 0) {
        clearUserExamInfo(data.id);
        clearTimeout(this.idleTimeoutListener);
        clearTimeout(this.timeoutListener);
        window.removeEventListener("beforeunload", this.beforeUnload);
        this.setState({
          tipsModal: false,
        });
        this.handleShowExamResult(data.historyId, "submit");
      }
    });
  };

  //查看考试结果
  handleShowExamResult = (id, status, practiceId) => {
    if (this.params.status !== "previewOtherExam") {
      getExamTrainList(this.params.id).then((res) => {
        if (res && res.code === 0) {
          this.setState({
            examTrainList: res.data,
          });
        }
      });
    }
    toExamQuestion({
      historyId: id,
      practiceId: practiceId || this.state.practiceId,
    }).then((res) => {
      if (res && res.code === 0) {
        let pageStatus = "passResult";
        if (status === "submit") {
          pageStatus = "passResult";
        } else {
          pageStatus = "examResult";
        }
        const keyObj = {
          0: "",
          1: intl.get("sentenceAccuracy"),
          2: intl.get("accurateWord"),
          3: intl.get("phoneticAccuracy"),
          4: intl.get("correctRhythm"),
        };
        if (res.data.scoreType) {
          let passingScore = [];
          Object.keys(res.data.scoreType).forEach((key) => {
            passingScore.push(
              keyObj[key] +
                (res.data.totalScore ? "分:" : ":") +
                (res.data.totalScore
                  ? Math.round(
                      (res.data.scoreType[key] * res.data.totalScore) / 100
                    )
                  : res.data.scoreType[key] + "%")
            );
          });
          res.data.passingScore = passingScore;
        }
        if (res.data.accuracy) {
          let accuracyScore = [];
          Object.keys(res.data.accuracy).forEach((key) => {
            accuracyScore.push(
              keyObj[key] +
                (key === "0" ? "" : res.data.totalScore ? "分:" : ":") +
                (res.data.totalScore
                  ? Math.round(
                      (res.data.accuracy[key] * res.data.totalScore) / 100
                    )
                  : res.data.accuracy[key] + "%")
            );
          });
          res.data.accuracyScore = accuracyScore;
        }
        this.setState({
          pageStatus: pageStatus,
          examQuestionInfo: res.data,
        });
      }
    });
  };

  //跳转培训
  redirectTrain = (trainId, workTypeId) => {
    let status = "train";
    //考官跳转培训
    if (this.params === "preview") {
      status = "preview";
    }
    limitTrainTask(trainId).then((res) => {
      if (res && res.code === 0) {
        const str = workTypeId ? "?type=" + workTypeId : "";
        window.open("/trainTask/" + trainId + "/" + status + str);
      }
    });
  };

  getContent = () => {
    if (this.state.tipsModal) {
      if (this.state.tipsType === "timeout") {
        return intl.get("4236732e-0f4e-267a-b406-0fe3e0594332");
      } else if (this.state.tipsType === "switch") {
        return intl.get("4d4d6ca3-3f34-22e6-8f76-2b07343746b7", {
          count: this.state.dataInfo?.switchingTimes,
        });
      } else if (this.state.tipsType === "noOperate") {
        return intl.get("6c8f6433-393d-2d7d-b5a6-d0f1bb8fb77c", {
          second: this.state.dataInfo?.timeoutTime,
        });
      } else if (this.state.tipsType === "fullscreen") {
        return intl.get("397eea22-337a-2d84-8a95-a36ae1ca35ae");
      } else if (this.state.tipsType.indexOf("submitNoDone") > -1) {
        const undoQID = this.state.tipsType.split("-")[1];
        return intl.get("9cb4fe53-c698-2c96-9616-1cdea6d8caf3", {
          index: undoQID,
        });
      } else if (this.state.tipsType === "submitDone") {
        return intl.get("be10fd2b-b65b-23c9-bbc4-d1a27e78c23a");
      } else if (this.state.tipsType === "introduce") {
        setTimeout(() => {
          const richTextDom = document.getElementById("richTextWrap");
          if (richTextDom) {
            richTextDom.innerHTML = this.state.dataInfo?.description;
          }
        }, 10);
        return (
          <div className="mT20 modalWrap">
            <p>
              {this.state.dataInfo?.switchingTimes &&
                intl.get("7d9de328-106e-23ea-a332-5212242aa3ba", {
                  count: this.state.dataInfo?.switchingTimes,
                })}
              {this.state.dataInfo?.timeoutTime &&
                intl.get("5a1415e7-9207-27f7-a621-65113cacce28", {
                  second: this.state.dataInfo?.timeoutTime,
                })}
              {(this.state.dataInfo?.switchingTimes ||
                this.state.dataInfo?.timeoutTime) &&
                intl.get("5efb4498-bad0-28d1-ae9b-aab59ae5c35a")}
            </p>
            {this.state.dataInfo?.description && (
              <p className="mT10" id="richTextWrap">
                {this.state.dataInfo?.description}
              </p>
            )}
          </div>
        );
      }
    }
  };

  toHandExam = (task) => {
    let macSign = localStorage.getItem("dots-mac");
    if (!macSign) {
      const macAdd = guid();
      localStorage.setItem("dots-mac", macAdd);
      macSign = macAdd;
    }
    //判断是否是同一电脑不同人做同一考试任务。
    checkExamTask({ macAddress: macSign, cultivateId: this.params.id }).then(
      (res) => {
        if (res && res.code === 0) {
          this.showReExamConfirm();
        }
      }
    );
  };

  //培训文档
  toggleDocument = () => {
    this.setState({ docVisible: !this.state.docVisible });
  };

  render() {
    return (
      <div className="boxContentWrap">
        <Watermark
          text={`${getUserInfoToLocal().name}${
            getUserInfoToLocal().uid
              ? getUserInfoToLocal().uid
              : getUserInfoToLocal().id
          }${intl.get("adeff155-6a7d-215c-bb8d-55298fca89d4")}`}
          key={this.useTime}
        />
        <Row className="headerWrap" justify={"space-between"}>
          <Col span="10">
            <Text ellipsis={{ tooltip: this.state.dataInfo?.name }}>
              {this.state.dataInfo?.name}{" "}
            </Text>
          </Col>
          <Col span="4" style={{ textAlign: "center" }}>
            {this.state.pageStatus === "exam" && (
              <span className="clickStyle mr10 fs14">
                <img className="btnIcon" src={hourglassImg} />
                {intl.get("6d4e25d1-8319-2e1b-9aba-211bffed1d0d")}：
                {this.getTime()}
              </span>
            )}
          </Col>
          <Col span="10" className="alignEnd">
            {/* 考试中页面 */}
            {this.state.pageStatus === "exam" && (
              <>
                <span className="header-right-line">|</span>
                {/* 培训文档 */}
                {this.state.previewFileList.length > 0 && (
                  <span
                    className="clickStyle mr10 fs14 fwn"
                    onClick={this.toggleDocument}
                  >
                    <ReadOutlined />
                    <b className="fw4">{intl.get("training_document")}</b>
                  </span>
                )}
                {/* 考试说明 */}
                <span
                  className="clickStyle mr10 fs14 fwn"
                  onClick={() => {
                    this.setState({ tipsType: "introduce", tipsModal: true });
                  }}
                >
                  <img className="btnIcon" src={introImg} />
                  <b className="fw4">
                    {intl.get("dbd16a1e-0651-279f-9803-c1300995c641")}
                  </b>
                </span>
                {/* 提交 */}
                {this.params.status === "exam" && (
                  <span className="subBtn fs14" onClick={this.showSubmitModal}>
                    <img className="btnIcon" src={submitImg} />
                    {intl.get("Submit_b4c78c66-cc86-21f2-9581-710c4b1acf9b")}
                  </span>
                )}
              </>
            )}
            {/* 考试结果页面 */}
            {/* 培训 */}
            {this.state.pageStatus === "examResult" &&
              this.state.examTrainList &&
              this.state.examTrainList.length > 0 && (
                <span
                  className="clickStyle mr10 fs14"
                  onClick={() => this.setState({ trainListModal: true })}
                >
                  <img className="btnIcon" src={trainImg} />
                  {intl.get("3ab83d68-d30b-20af-854c-b55fe7b30d19")}
                </span>
              )}
            {/* 考试结果页面||通过结果页面*/}
            {this.state.pageStatus.indexOf("Result") > -1 &&
              this.params.status === "exam" &&
              this.state.examQuestionInfo?.isPassed !== 2 &&
              this.state.examQuestionInfo?.examRemainTimes > 0 && (
                //重考： 剩余考试次数大于0，未通过
                <span
                  className="clickStyle mr10 fs14 fwn"
                  onClick={this.toHandExam}
                >
                  <img className="btnIcon" src={reExamImg} />
                  {intl.get("93672963-7a6b-2bd0-ab43-4338701e1d64")}
                </span>
              )}
          </Col>
        </Row>
        <div className="contentHolder">
          {["examResult", "exam"].includes(this.state.pageStatus) &&
            this.state.workTypeId && <div ref={this.containerRef}></div>}
          {/* 考试中页面 */}
          {this.state.pageStatus === "exam" && !this.state.workTypeId && (
            <div className="resultTitleWrap">
              {/* 总分数 */}
              <span className="itemWrap">
                {intl.get("d37a62f1-b5e1-23e5-bd95-3c477cbfe8ae")}：
                {this.state.examQuestionInfo?.totalScore}
              </span>
              {/* 总题数 */}
              <span className="itemWrap">
                {intl.get("39e94fb7-29dc-2f00-8d8f-e015addc5709")}：
                {this.state.examQuestionInfo?.questions.length}
              </span>
              {/* 用时 */}
              {/* <span className="itemWrap">{intl.get("9bb6ca20-830e-230b-9992-9326ad980970", {
              minute: examQuestionInfo?.examUseTime < 60 ? 0 : Math.floor(this.state.examQuestionInfo?.examUseTime / 60), second: (this.state.examQuestionInfo?.examUseTime % 60).toFixed(0)
            })}</span> */}
              {/* 考试次数 */}
              <span className="itemWrap">
                {intl.get("e1e09ac1-c114-2949-af40-da52ed0f0494")}:{" "}
                {this.params.status === "preview"
                  ? 1
                  : this.state.examQuestionInfo?.frequency}
              </span>
            </div>
          )}
          {/* 考试结果页面 */}
          {this.state.pageStatus === "examResult" && !this.state.workTypeId && (
            <div>
              <div className="resultTitleWrap">
                {/* 得分 */}
                <span className="itemWrap">
                  {intl.get("3fe01df5-dc92-22fc-9acd-82d6601ae672")}:{" "}
                  {this.state.examQuestionInfo?.score}/
                  <span className="grayFont">
                    {this.state.examQuestionInfo?.totalScore}
                  </span>
                </span>
                {/* 答对题数 */}
                <span className="itemWrap">
                  {intl.get("ee6153bf-a153-250c-a75e-d5e5f6d7e938")}:{" "}
                  {this.state.examQuestionInfo?.correctNum}/
                  <span className="grayFont">
                    {this.state.examQuestionInfo?.totalNum}
                  </span>
                </span>
                {/* 用时 */}
                <span className="itemWrap">
                  {intl.get("9bb6ca20-830e-230b-9992-9326ad980970", {
                    minute:
                      this.state.examQuestionInfo?.useTime < 60
                        ? 0
                        : Math.floor(this.state.examQuestionInfo?.useTime / 60),
                    second: (this.state.examQuestionInfo?.useTime % 60).toFixed(
                      0
                    ),
                  })}
                </span>
                {/* 考试次数 */}
                <span className="itemWrap">
                  {intl.get("e1e09ac1-c114-2949-af40-da52ed0f0494")}:{" "}
                  {this.params.status === "preview"
                    ? 1
                    : this.state.examQuestionInfo?.frequency}
                </span>
              </div>
              {/* 答案解析|错题 */}
              <div className="tabWrap">
                <Segmented
                  options={[
                    {
                      label: (
                        <span>
                          {intl.get("2ac9ebd2-34d3-246b-ae56-691fc72352a6")}
                        </span>
                      ),
                      value: 1,
                    },
                    {
                      label: (
                        <span>
                          {intl.get("2fe854d4-a57b-27bb-a9d0-f120fa9bf1ce")}
                        </span>
                      ),
                      value: 2,
                    },
                  ]}
                  value={this.state.tabValue}
                  onChange={(e) => this.setState({ tabValue: e })}
                />
              </div>
            </div>
          )}
          {/* 考试试题 */}
          {this.state.pageStatus.indexOf("exam") > -1 &&
            !this.state.workTypeId &&
            this.state.examQuestionInfo?.questions.map((question, i) => {
              if (question.selectQuestionOptionId) {
                question.options.map((o) => {
                  if (question.selectQuestionOptionId.indexOf(o.id) > -1) {
                    o.answer = true;
                  }
                });
              }
              return (
                <Question
                  key={`question-${question.id}`}
                  canEdit={false}
                  index={i}
                  data={question}
                  isLargeJudge={this.params.status === "exam"}
                  largeJudge={this.largeJudge}
                  isOnlyShowError={this.state.tabValue === 2}
                  changeQuestion={this.changeQuestion}
                  status={this.state.pageStatus}
                  hideDeleteBtn
                />
              );
            })}
          {/* 考试通过与否结果页面:考生展示 */}
          {this.state.pageStatus === "passResult" &&
            this.params.status === "exam" && (
              <div className="resultContent">
                <div className="center">
                  <img
                    className={
                      this.state.examQuestionInfo?.isPassed === 2
                        ? "resultSuccessIcon"
                        : "resultIcon"
                    }
                    src={
                      this.state.examQuestionInfo?.isPassed === 2
                        ? successImg
                        : errorImg
                    }
                  />
                  <div className="resultTips">
                    {this.state.examQuestionInfo?.isPassed === 2
                      ? intl.get("12307db9-2e7c-2506-bbd4-f8071829ae3d")
                      : intl.get("62749956-241e-2889-bfbd-16af9941d671")}
                  </div>
                  <Row className="examResultWrap">
                    <Col
                      span={!this.state.workTypeId ? 12 : 4}
                      className="borderRight"
                    >
                      <p>{intl.get("e1e09ac1-c114-2949-af40-da52ed0f0494")}</p>
                      <p>
                        <h2>
                          <b>{this.state.examQuestionInfo?.frequency}</b>
                        </h2>
                      </p>
                    </Col>
                    {this.state.workTypeId && (
                      <Col span={10} className="borderRight">
                        <p>{intl.get("passing_score")}</p>
                        <p>
                          {(this.state.examQuestionInfo.passingScore || []).map(
                            (ite) => (
                              <h2>
                                <b>{ite}</b>
                              </h2>
                            )
                          )}
                        </p>
                      </Col>
                    )}
                    <Col span={10}>
                      <p>
                        {intl.get(
                          this.state.examQuestionInfo?.totalScore
                            ? "3fe01df5-dc92-22fc-9acd-82d6601ae672"
                            : "AccuracyRate"
                        )}
                      </p>
                      <p>
                        {(this.state.examQuestionInfo.accuracyScore || []).map(
                          (ite) => (
                            <h2>
                              <b>{ite}</b>
                            </h2>
                          )
                        )}
                      </p>
                    </Col>
                  </Row>
                  {/* 关联的培训列表 */}
                  {this.state.examTrainList &&
                    this.state.examTrainList.length > 0 && (
                      <div className="trainListWrap">
                        <p>
                          <h2>
                            <b>
                              {this.state.examQuestionInfo?.isPassed !== 2
                                ? intl.get(
                                    "c498cbc1-8982-2bb6-b1a9-d1aee1722b00"
                                  )
                                : `${intl.get(
                                    "c645ff8f-2e21-2684-94d3-fd7aff69bd87"
                                  )}：`}
                            </b>
                          </h2>
                        </p>
                        {this.state.examTrainList?.map((train) => {
                          return (
                            <p
                              className="clickBlock mt10"
                              onClick={() =>
                                this.redirectTrain(train.id, train.workTypeId)
                              }
                            >
                              {train.name}（
                              {intl.get("fcffe4b7-3f76-20e2-9d3c-c7f3dfd81bf4")}
                              ：
                              {train.skillsFieldName
                                ? train.skillsFieldName
                                : intl.get(
                                    "2c2ddaef-39e6-2158-a0b6-df3e2123ce42"
                                  )}
                              ）
                            </p>
                          );
                        })}
                      </div>
                    )}
                  {/* 查看结果详情||确定*/}
                  <div className="mT20">
                    {this.state.dataInfo.showAnswer === 1 ? (
                      <Button
                        type="primary"
                        onClick={() =>
                          this.handleShowExamResult(
                            this.state.examQuestionInfo.id
                          )
                        }
                      >
                        {intl.get("585d5064-f1e1-2e39-b1de-bedc056714af")}
                      </Button>
                    ) : (
                      <Button type="primary" onClick={() => window.close()}>
                        {intl.get("ffab6c18-d433-2358-9e00-55e04781c4c6")}
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            )}
        </div>
        {/* 培训任务选择弹窗 */}
        {this.state.trainListModal && (
          <Modal
            title={intl.get("3ab83d68-d30b-20af-854c-b55fe7b30d19")}
            open={this.state.trainListModal}
            bodyStyle={{ maxHeight: "500px", overflowY: "auto" }}
            footer={null}
            onCancel={() => this.setState({ trainListModal: false })}
          >
            <div>{intl.get("4a2f8ced-cc47-265d-8513-9a9bcb6c6f10")}：</div>
            {this.state.examTrainList?.map((train) => {
              return (
                <p
                  className="clickBlock mt10"
                  onClick={() => this.redirectTrain(train.id, train.workTypeId)}
                >
                  {train.name}（
                  {intl.get("fcffe4b7-3f76-20e2-9d3c-c7f3dfd81bf4")}：
                  {train.skillsFieldName
                    ? train.skillsFieldName
                    : intl.get("2c2ddaef-39e6-2158-a0b6-df3e2123ce42")}
                  ）
                </p>
              );
            })}
            <div className="alignCenter mT20">
              <Button
                type="primary"
                onClick={() => this.setState({ trainListModal: false })}
              >
                {intl.get("ffab6c18-d433-2358-9e00-55e04781c4c6")}
              </Button>
            </div>
          </Modal>
        )}
        {this.state.tipsModal &&
          this.state.pageStatus === "exam" &&
          this.state.examQuestionInfo.isSubmit !== 1 && (
            <Modal
              title={intl.get("Tips_f41babef-2238-24b3-8e39-bdb7bcb07d16")}
              open={this.state.tipsModal}
              onCancel={() => {
                if (this.state.tipsType.indexOf("submit") > -1) {
                  this.setState({ tipsModal: false });
                }
              }}
              closable={this.state.tipsType.indexOf("submit") > -1}
              footer={null}
            >
              <div>{this.getContent()}</div>
              <div className="alignCenter mT20">
                {this.state.tipsType === "fullscreen" ||
                this.state.tipsType === "introduce" ||
                this.state.tipsType.indexOf("submit") > -1 ? (
                  <>
                    <Button
                      type={
                        this.state.tipsType.indexOf("submit") > -1
                          ? "default"
                          : "primary"
                      }
                      onClick={() => this.setState({ tipsModal: false })}
                    >
                      {this.state.tipsType.indexOf("submit") > -1
                        ? intl.get(
                            "Cancel_51f2be22-0a99-2045-95f1-81feae4ea69d"
                          )
                        : intl.get("ffab6c18-d433-2358-9e00-55e04781c4c6")}
                    </Button>
                    {this.state.tipsType.indexOf("submit") > -1 && (
                      <Button
                        className="ml15"
                        type="primary"
                        onClick={this.handleSubmitClick}
                      >
                        {intl.get(
                          "Submit_b4c78c66-cc86-21f2-9581-710c4b1acf9b"
                        )}
                      </Button>
                    )}
                  </>
                ) : (
                  <Button
                    type="primary"
                    onClick={() => this.handleSubmitClick(true)}
                  >
                    {intl.get("Submit_b4c78c66-cc86-21f2-9581-710c4b1acf9b")}
                  </Button>
                )}
              </div>
            </Modal>
          )}
        {this.state.docVisible && (
          <Document
            docs={this.state.previewFileList}
            onClose={this.toggleDocument}
          ></Document>
        )}
      </div>
    );
  }
}
export default Task;
